$(function () {
    if ($.validator) {
        //get the reference to the original function into a local variable
        var _getLength = $.validator.prototype.getLength;

        //overwrite existing getLength of validator
        $.validator.prototype.getLength = function (value, element) {

            //double count line breaks for textareas only
            if (element.nodeName.toLowerCase() === 'textarea') {

                //Counts all the newline characters (\r = return for macs, \r\n for Windows, \n for Linux/unix)
                var newLineCharacterRegexMatch = /\r?\n|\r/g;

                if (element.value) {

                    //count newline characters
                    var regexResult = element.value.match(newLineCharacterRegexMatch);
                    var newLineCount = regexResult ? regexResult.length : 0;

                    //return the length of text without newline characters + doubled newline character count
                    var replacedValue = element.value.replace(newLineCharacterRegexMatch, "");
                    return replacedValue.length + (newLineCount * 2);
                } else {
                    return false;
                }
            }
            //call the original function reference with apply
            return _getLength.apply(this, arguments);
        };
    }
});